@if (horizontalMenu) {
	<div class="navbar-header d-xl-block d-none">
		<!-- Navbar brand -->
		<ul class="nav navbar-nav flex-row">
			<li class="nav-item">
				<a class="navbar-brand" (click)="redirectToHome()">
					<!--  <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36"/>
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2> -->
				</a>
			</li>
		</ul>
		<!--/ Navbar brand -->
	</div>
}

<div class="navbar-container d-flex content align-items-center">
	<div class="bookmark-wrapper d-flex align-items-center">
		<!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
		@if (!coreConfig.layout.menu.hidden) {
			<ul class="nav navbar-nav d-xl-none">
				<li class="nav-item">
					<a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
						<span [data-feather]="'menu'" [class]="'ficon'"></span>
					</a>
				</li>
			</ul>
		}
		<!--/ Menu Toggler -->
		<!-- *ngIf="clinica.codice !== 'miaclinica'" -->

		<li class="nav-item d-block">
			<span class="font-weight-bolder" style="padding-left: 8px">
				@if (!currentUniversity || currentUniversity?.logo) {
					<img
						[ngClass]="{ 'logo-university': currentUniversity, 'logo-didact': !currentUniversity }"
						[src]="currentUniversity ? beUrl + '/storage/' + $safeNavigationMigration(currentUniversity.logo?.path) : ''"
						[alt]="currentUniversity?.logo ? ('common_label_portal_logo_alt' | translate) : ''" />
				} @else {
					{{ currentUniversity | entityName }}
				}
			</span>
		</li>
	</div>

	@if (currentUniversity && currentSchool) {
		<div class="nav navbar-nav align-items-center ms-auto px-2 mt-1 d-lg-block d-none">
			<h3>{{ $safeNavigationMigration(currentSchool?.school) | entityName }}</h3>
			@if (_currentCareerActive.currentCareer.value?.school_university_sub_school?.sub_school?.name) {
				<h6 class="text-center">{{ _currentCareerActive.currentCareer.value.school_university_sub_school.sub_school | entityName }}</h6>
			}
		</div>
	}

	<div class="nav navbar-nav align-items-center ms-auto me-1">
		@if (
			(currentUniversity &&
				currentSchool &&
				activeProfile?.profile?.layout_type_id === LayoutType.BackOffice &&
				activeProfile?.profile?.profile_type_id !== ProfileType.School) ||
			(activeProfile?.profile?.profile_type_id === ProfileType.Multitenant &&
				_currentUniversityService?.currentUniversityId?.value &&
				_currentSchoolUniversityService?.currentSchoolId?.value)
		) {
			<span class="user-name font-weight-bolder fa-xl"
				><fa-icon
					[icon]="'arrow-up-right-from-square'"
					[ngbTooltip]="'navbar_tooltip_back_to_university' | translate"
					(click)="exitSchool()"
					>></fa-icon
				></span
			>
		} @else {
			@if (
				(currentUniversity &&
					!currentSchool &&
					activeProfile?.profile?.layout_type_id === LayoutType.BackOffice &&
					activeProfile?.profile?.profile_type_id !== ProfileType.School &&
					activeProfile?.profile?.profile_type_id !== ProfileType.University) ||
				(activeProfile?.profile?.profile_type_id === ProfileType.Multitenant &&
					_currentUniversityService?.currentUniversityId?.value &&
					!_currentSchoolUniversityService?.currentSchoolId?.value)
			) {
				<span class="user-name font-weight-bolder fa-xl"
					><fa-icon
						[icon]="'arrow-up-right-from-square'"
						[ngbTooltip]="'navbar_tooltip_back_to_multitenant' | translate"
						(click)="exitUniversity()"
						>></fa-icon
					></span
				>
			}
		}
	</div>

	@if (currentUser) {
		<ul class="nav navbar-nav align-items-center">
			<!-- <app-navbar-notification
        *ngIf="menu === 'frontend' && currentUser.profile_users[0].profile.name === 'Specializzando'"></app-navbar-notification> -->
			@if (activeLanguage) {
				<li ngbDropdown class="nav-item dropdown-language">
					<a
						class="nav-link"
						ngbDropdownToggle
						id="navbarLanguageDropdown"
						[attr.aria-label]="'navbar_user_language' | translate"
						[attr.title]="activeLanguage.label"
						aria-haspopup="true"
						aria-expanded="false">
						<span style="font-size: 1.15rem; line-height: 1">{{ activeLanguage.flag }}</span>
					</a>
					<div ngbDropdownMenu aria-labelledby="navbarLanguageDropdown" class="dropdown-menu dropdown-menu-end">
						@for (lang of appLanguages; track lang.code) {
							<a ngbDropdownItem (click)="translate(lang.code)" class="d-flex align-items-center justify-content-between">
								<span class="d-flex align-items-center">
									<span class="me-2" style="font-size: 1.15rem; line-height: 1">{{ lang.flag }}</span>
									<span>{{ lang.label }}</span>
								</span>
								@if (_translateService.currentLang === lang.code) {
									<fa-icon icon="check" class="ms-3 text-success"></fa-icon>
								}
							</a>
						}
					</div>
				</li>
			}

			<app-navbar-notification></app-navbar-notification>
			<li ngbDropdown class="nav-item dropdown-user" style="margin-left: 5px">
				<a
					class="nav-link dropdown-toggle dropdown-user-link"
					id="dropdown-user"
					ngbDropdownToggle
					id="navbarUserDropdown"
					aria-haspopup="true"
					aria-expanded="false">
					<div class="user-nav d-flex align-items-center">
						<span class="user-name font-weight-bolder d-sm-none"><fa-icon [icon]="'cog'" class="fa-xl"></fa-icon></span>
						<span class="user-name font-weight-bolder d-none d-sm-block mt-1"
							><h4>{{ currentUser?.name }} {{ currentUser?.surname }}</h4></span
						>
					</div>
					@if (getProfilePictureUrl(currentUser)) {
						<div class="navbar-user-avatar me-1">
							<img [src]="getProfilePictureUrl(currentUser)" alt="{{ 'common_label_profile_photo_alt' | translate }}" />
						</div>
					} @else {
						<div class="navbar-user-avatar navbar-user-avatar-fallback me-1">
							{{ getUserInitials(currentUser) }}
						</div>
					}
				</a>
				<div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
					@if (
						_authenticationService.currentUserObj?.value?.profile_users?.length > 1 ||
						(_authenticationService.currentUserObj?.value?.profile_users?.length <= 1 &&
							_authenticationService.currentUserObj?.value?.profile_users[0]?.profile_user_university
								?.profile_user_university_school_universities.length > 1) ||
						careers?.length > 1
					) {
						<a ngbDropdownItem (click)="cambiaProfilo(false)">
							<span [data-feather]="'users'" [class]="'mr-50'"></span> {{ 'navbar_user_change_profile' | translate }}
						</a>
					}
					<a ngbDropdownItem (click)="navigateToProfile()">
						<span [data-feather]="'user'" [class]="'mr-50'"></span> {{ 'navbar_user_profile' | translate }}
					</a>
					@if (currentUniversity?.help_desk_url) {
						<a ngbDropdownItem [href]="currentUniversity.help_desk_url" target="_blank" rel="noopener noreferrer">
							<span [data-feather]="'help-circle'" [class]="'mr-50'"></span> {{ 'navbar_user_help_desk' | translate }}
						</a>
					}
					<div class="dropdown-divider"></div>
					<h6 class="dropdown-header">{{ 'navbar_user_language' | translate }}</h6>
					@for (lang of appLanguages; track lang) {
						<a ngbDropdownItem (click)="translate(lang.code)" class="d-flex align-items-center justify-content-between">
							<span class="d-flex align-items-center">
								<span class="me-2" style="font-size: 1.15rem; line-height: 1">{{ lang.flag }}</span>
								<span>{{ lang.label }}</span>
							</span>
							@if (_translateService.currentLang === lang.code) {
								<fa-icon icon="check" class="ms-3 text-success"></fa-icon>
							}
						</a>
					}
					<div class="dropdown-divider"></div>
					<a ngbDropdownItem (click)="logout()">
						<span [data-feather]="'power'" [class]="'mr-50'"></span> {{ 'navbar_user_logout' | translate }}
					</a>
				</div>
			</li>
		</ul>
	}
</div>
